import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseLayoutComponent } from './core/components/base-layout/base-layout.component';
import { GlobalAuthFilter } from './core/auth/templates-mgt/guards/global-auth-filter.guard';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: '',
    component: BaseLayoutComponent,
    canActivate: [MsalGuard],
    canActivateChild: [MsalGuard, GlobalAuthFilter],
    children: [
      {
        title: 'Fordesk | Templates',
        path: 'templates',
        loadChildren: async () => (await import('./modules/mail-merge-templates/mail-merge-templates.module')).MailMergeTemplatesModule,
      },
      {
        path: '',
        redirectTo: '/templates',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
